import { render, staticRenderFns } from "./PerderOferta.vue?vue&type=template&id=4df0951a"
import script from "./PerderOferta.vue?vue&type=script&lang=js"
export * from "./PerderOferta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports